import { useActiveWorkspace } from '@/true-fsd/data/advertiser-account/hooks'
import { SiteIntegrationWidget } from '@/widgets/settings'

export const SiteIntegrationPage = () => {
    const { activeWorkspace } = useActiveWorkspace()

    if (activeWorkspace.workspace_type !== 'site') {
        return null
    }

    return <SiteIntegrationWidget siteId={activeWorkspace.site_id} />
}
